import _slicedToArray from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import Link from "next/link";
import { Map, Marker, Popup, TileLayer, Tooltip, Circle } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Stars from "./Stars";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MapLeaflet = function MapLeaflet(props) {
  var tileLayers = [{
    tiles: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: "abcd"
  }, {
    tiles: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }, {
    tiles: "https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}{r}.png",
    attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }, {
    tiles: "https://mapserver.mapy.cz/base-m/{z}-{x}-{y}",
    attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>, <a href="https://seznam.cz">Seznam.cz, a.s.</a>'
  }, {
    tiles: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: "abcd"
  }, {
    tiles: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia maps</a>'
  }];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      focus = _React$useState4[0],
      setFocus = _React$useState4[1];

  var icon = L.icon({
    iconUrl: "/content/svg/marker.svg",
    shadowUrl: "",
    iconRetinaUrl: "/content/svg/marker.svg",
    iconSize: [25, 37.5],
    popupAnchor: [0, -18],
    tooltipAnchor: [0, 19]
  });
  var highlightIcon = L.icon({
    iconUrl: "/content/svg/marker-hover.svg",
    shadowUrl: "",
    iconRetinaUrl: "/content/svg/marker-hover.svg",
    iconSize: [25, 37.5],
    popupAnchor: [0, -18],
    tooltipAnchor: [0, 19]
  });
  var markers = props.geoJSON && props.geoJSON.features && props.geoJSON.features.map(function (feature) {
    return [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
  });
  return /*#__PURE__*/_jsxs(Map, {
    center: props.center && props.center,
    zoom: props.zoom,
    scrollWheelZoom: focus,
    className: props.className,
    dragging: props.dragging,
    tap: props.tap,
    bounds: props.geoJSON ? markers : null,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    children: [/*#__PURE__*/_jsx(TileLayer, {
      url: tileLayers[1].tiles,
      attribution: tileLayers[1].attribution
    }), props.geoJSON && props.geoJSON.features && props.geoJSON.features.map(function (feature) {
      var data = feature.properties;
      return props.popupVenue ? /*#__PURE__*/_jsx(Marker, {
        position: [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
        onMouseOver: function onMouseOver() {
          setHover(data.id);
        },
        onMouseOut: function onMouseOut() {
          setHover(false);
        },
        icon: hover === data.id || props.hoverCard === feature.properties.id ? highlightIcon : icon,
        children: /*#__PURE__*/_jsx(Popup, {
          className: "map-custom-popup",
          maxWidth: "600",
          minWidth: "200",
          children: /*#__PURE__*/_jsxs("div", {
            className: "popup-venue",
            children: [data.image ? /*#__PURE__*/_jsx("div", {
              className: "image d-none d-md-block",
              style: {
                backgroundImage: "url(".concat(data.image)
              }
            }) : /*#__PURE__*/_jsx("div", {
              className: "image"
            }), /*#__PURE__*/_jsxs("div", {
              className: "text",
              children: [data.name && /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: data.link,
                  children: /*#__PURE__*/_jsx("a", {
                    children: data.name
                  })
                })
              }), data.about && /*#__PURE__*/_jsx("p", {
                children: data.about
              }), data.address && /*#__PURE__*/_jsx("p", {
                className: "text-muted mb-1",
                children: data.address
              }), data.email && /*#__PURE__*/_jsxs("p", {
                className: "text-muted mb-1",
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fas fa-envelope-open fa-fw text-dark mr-2"
                }), /*#__PURE__*/_jsx("a", {
                  href: "mailto:".concat(data.email),
                  children: data.email
                })]
              }), data.phone && /*#__PURE__*/_jsxs("p", {
                className: "text-muted mb-1",
                children: [/*#__PURE__*/_jsx("i", {
                  className: "fa fa-phone fa-fw text-dark mr-2"
                }), data.phone]
              })]
            })]
          })
        })
      }, data.id) : /*#__PURE__*/_jsxs(Marker, {
        icon: icon,
        opacity: 0,
        position: [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
        onMouseOver: function onMouseOver() {
          setHover(data.id);
        },
        onMouseOut: function onMouseOut() {
          setHover(false);
        },
        children: [/*#__PURE__*/_jsxs(Tooltip, {
          permanent: true,
          interactive: true,
          direction: "top",
          className: "map-custom-tooltip ".concat(hover === data.id || props.hoverCard === feature.properties.id ? "active" : ""),
          children: ["\u20AC ", data.price]
        }), /*#__PURE__*/_jsx(Popup, {
          className: "map-custom-popup",
          maxWidth: "600",
          minWidth: "200",
          children: /*#__PURE__*/_jsxs("div", {
            className: "popup-rental",
            children: [data.image ? /*#__PURE__*/_jsx("div", {
              className: "image d-none d-md-block",
              style: {
                backgroundImage: "url(".concat(data.image, ")")
              }
            }) : /*#__PURE__*/_jsx("div", {
              className: "image"
            }), /*#__PURE__*/_jsxs("div", {
              className: "text",
              children: [data.name && /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx(Link, {
                  href: data.link,
                  children: /*#__PURE__*/_jsx("a", {
                    children: data.name
                  })
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "text-xs"
              })]
            })]
          })
        })]
      }, data.id);
    }), props.markerPosition && /*#__PURE__*/_jsx(Marker, {
      position: props.markerPosition,
      icon: icon
    }), props.circlePosition && /*#__PURE__*/_jsx(Circle, {
      center: props.circlePosition,
      color: "#4E66F8",
      fillColor: "#8798fa",
      opacity: 0.5,
      radius: props.circleRadius,
      weight: 2
    })]
  });
};

export default MapLeaflet;